export default __webpack_public_path__ + "static/media/EnrollmentBG.0217aa3a.jpg";